"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HomeDisplaySettingContainer = void 0;
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _HomeDisplaySettingMain = _interopRequireDefault(require("./HomeDisplaySettingMain"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ホーム表示設定コンテナ
 */
class HomeDisplaySettingContainer extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_HomeDisplaySettingMain.default, null);
  }
}
exports.HomeDisplaySettingContainer = HomeDisplaySettingContainer;
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)(HomeDisplaySettingContainer));